'use strict';
import {settings} from '../../../variables.js'
var apiBaseUrl = settings.apiBaseUrl

angular.
module('core.rent')
    .factory('SupportList', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/support/api/support-list/',
            {}
        )
    }])
    .factory('Support', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/support/api/support-item/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('SupportComment', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/support/api/support-comment/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('SupportCommentsList', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/support/api/support-comments/',
            {}
        )
    }])
;